import type { AxiosResponse } from 'axios';

import api from '@/utils/axiosInterceptor';
import type { ApiResponse } from '@/utils/deepmerge';

import type {
  ICompanyListApi,
  ICompanySupplyReport,
} from './CompanyItems.interface';

export async function GetCompanyItemsDataSupplyApi({
  endDate,
  startDate,
  id,
}: {
  id: number;
  startDate: string;
  endDate: string;
}) {
  // eslint-disable-next-line no-useless-catch
  try {
    const response: AxiosResponse<ApiResponse<ICompanySupplyReport>> =
      await api.get(
        `/items-card/company-items-supply?id=${id}&startDate=${startDate}&endDate=${endDate}`,
      );
    return response?.data;
  } catch (err) {
    throw err;
  }
}

export async function GetCompaniesListApi() {
  // eslint-disable-next-line no-useless-catch
  try {
    const response: AxiosResponse<ApiResponse<ICompanyListApi>> = await api.get(
      `/items-card/companies-list`,
    );
    return response?.data;
  } catch (err) {
    throw err;
  }
}
